// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"636":"b5a6380a1fe1249e","9021":"3904193dac6640f7"}[chunkId] + ".css";
};